import { render, staticRenderFns } from "./DriverStatusCard.vue?vue&type=template&id=9f0c52d2&scoped=true&"
import script from "./DriverStatusCard.vue?vue&type=script&lang=js&"
export * from "./DriverStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatusCard.vue?vue&type=style&index=0&id=9f0c52d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c52d2",
  null
  
)

export default component.exports